import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { bindRefs } from '../../utils/react.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { jsx } from 'react/jsx-runtime';

var containerStyle = {
  display: "inline-block",
  position: "absolute",
  visibility: "hidden",
  zIndex: -1
};

var Truncate = function Truncate(_ref) {
  var children = _ref.children,
      _ref$maxCharLength = _ref.maxCharLength,
      maxCharLength = _ref$maxCharLength === void 0 ? 25 : _ref$maxCharLength,
      tooltipContent = _ref.tooltipContent;
  var content = tooltipContent ? tooltipContent : children;
  var containerRef = React.useRef(null);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      truncated = _React$useState2[0],
      setTruncated = _React$useState2[1];

  var isTruncated = function isTruncated() {
    if (!containerRef.current) return;
    var container = document.createElement("div");
    Object.assign(container.style, containerStyle);
    container.setAttribute("aria-hidden", "true");
    var nodeClone = containerRef.current.cloneNode(true);
    var nodeChildren = nodeClone.querySelectorAll("*");
    nodeChildren.forEach(function (child) {
      child.setAttribute("style", "display: inline");
    });
    container.appendChild(nodeClone);
    containerRef.current.appendChild(container);
    setTruncated(nodeClone.scrollWidth > nodeClone.clientWidth);
    containerRef.current.removeChild(container);
  };

  React.useEffect(function () {
    isTruncated();
    window.addEventListener("resize", isTruncated);
    return function () {
      return window.removeEventListener("resize", isTruncated);
    };
  }, []);
  return /*#__PURE__*/jsx(Tooltip, {
    content: truncated ? content : void 0,
    position: "bottom",
    children: /*#__PURE__*/React.cloneElement(children, {
      ref: bindRefs(children.ref, containerRef),
      style: _objectSpread(_objectSpread({}, children.props.style), {}, {
        display: "inline-block",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: maxCharLength * 8
      })
    })
  });
};

Truncate.propTypes = {
  "children": _PropTypes.element,
  "maxCharLength": _PropTypes.number,
  "tooltipContent": _PropTypes.node
};
Truncate.displayName = "Truncate";

export { Truncate };
